import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './FreezeLayer.scss';

export function FreezeLayer(): JSX.Element {
	useStyles(s);
	return <div className="le-freeze-layer" sl-test-data="cmpLEFreezeLayer" />;
}
